import { Office } from "../office";
import { EvCarModel } from "../common";
import { Charger } from "../charger";

export const CHARGER_TYPE_STANDARD = "0";
export const CHARGER_TYPE_QUICK = "1";

export type ChargeSupplyTransactions = {
  id?: number;
  officeId: number;
  chargerId: number;
  chargers: Charger;
  type: typeof CHARGER_TYPE_STANDARD | typeof CHARGER_TYPE_QUICK;
  recievedAt: string;
  transactionId: string;
  startAt: string;
  endAt: string;
  chargeKwh: number;
  chargeCardManagementNumber: string;
  evCarId: number;
  offices: Office;
  evCars?: TransactionsEvCar;
};

export interface SearchChargeSupplyTransactions {
  usageStartOn?: string;
  usageEndOn?: string;
  officeId?: number;
  vehicleCode?: string;
}

export interface SearchChargeSupplyTransactionsValidator {
  usageStartOn?: boolean;
  usageEndOn?: boolean;
  officeId?: boolean;
  vehicleCode?: boolean;
}

export type ChargeSupplyTransactionsSortKey =
  | "startAt"
  | "endAt"
  | "evCars.cars.vehicleCode";

export type ChargeSupplyTransactionsOrderTypes = {
  startAt?: "asc" | "desc" | undefined;
  endAt?: "asc" | "desc" | undefined;
  "evCars.cars.vehicleCode"?: "asc" | "desc" | undefined;
};

export type TransactionsEvCar = {
  id: number;
  evCarModelId: number;
  evCarModels?: EvCarModel;
  carId: number;
  cars?: TransactionCar;
  evCarBatteryId: number;
  imei: string;
  imei2: string;
  vin: string;
  usageStartOn: string;
  usageEndOn: string;
  frontDriverWorkCycleId: number;
  backDriverWorkCycleId: number;
  subsidyType: string;
};

export type TransactionCar = {
  id: number;
  officeId: number;
  offices: Office;
  carModelId: number;
  driverAppKitId: number;
  vehicleCode: string;
  capable: number;
  serviceStatus: number;
};

export const ChargerDivision = ["普通", "急速"];

export type CsupCsvData = {
  displayName: string;
  startAt: string;
  endAt: string;
  type: string;
  chargerName: string;
  chargeCardManagementNumber?: string;
  evCarModelName?: string;
  vehicleCode?: string;
  chargeKwh: number;
}
